var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BBP-popups-file",style:(_vm.position)},[_c('span',{on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('BBPFileCell',{attrs:{"row":_vm.row,"column":_vm.column,"from-params":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb261676","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPPopups/BBPPopupsFile.vue
// module id = null
// module chunks = 